// src/firebase.ts
import { initializeApp, getApps, getApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// PUBLIC web config from Firebase console
const firebaseConfig = {
  apiKey: "AIzaSyDuWbN53Bj0WNzrX8n-sx8AiubfMUtRtnA",
  authDomain: "invoice-instagram.firebaseapp.com",
  projectId: "invoice-instagram",
  storageBucket: "invoice-instagram.firebasestorage.app",
  messagingSenderId: "178090363819",
  appId: "1:178090363819:web:91c52cf7ef35dcb9cce0ee",
  measurementId: "G-RET1ZY8YN4"
};

// Make sure we only init once (fixes Fast Refresh “duplicate app” errors)
export const firebaseApp =
  getApps().length ? getApp() : initializeApp(firebaseConfig);

const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
if (!siteKey) {
  // Helpful guard so this never silently fails again
  // eslint-disable-next-line no-console
  console.error('Missing REACT_APP_RECAPTCHA_SITE_KEY in .env.local (and in Vercel envs).');
  throw new Error('App Check site key missing');
}

console.log(siteKey);


// App Check with reCAPTCHA v3 (or Enterprise)
export const appCheck = initializeAppCheck(firebaseApp, {
  provider: new ReCaptchaV3Provider(siteKey),
  isTokenAutoRefreshEnabled: true,
});
